module.exports = __webpack_public_path__ + "static/media/arrow_hover.50048d2b.png";